import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_CONSULTANTS_EDITED_TOTAL_PAY } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const consultantsEditedTotalPay = {
  namespaced: true,
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus
  },
  actions: {
    getConsultantsEditedTotalPay ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting total pay, please wait...' })
      return api.doGet({ path: PATH_CONSULTANTS_EDITED_TOTAL_PAY, parameters: filters })
        .then(json => json.data)
        .then(editedTotalPay => {
          commit('updateStatus', { status: COMPLETE })
          return editedTotalPay[0]
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get total pay')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    // A silent, no-UI lookup for callers checking for an override as a side signal rather than as
    // the screen's main subject (e.g. a banner on a different report) - the regular action's
    // blocking "Getting total pay" modal and "Unable to get total pay" error toast would be
    // misleading noise on a screen not otherwise about pay overrides. Returns every matching
    // record rather than just the first, since a date-bounded filter here is an overlap check
    // the caller does client-side (override periods are payroll periods, e.g. biweekly, and
    // rarely align to whatever calendar range the caller is asking about).
    getConsultantsEditedTotalPaySilently (context, filters = {}) {
      return api.doGet({ path: PATH_CONSULTANTS_EDITED_TOTAL_PAY, parameters: filters })
        .then(json => json.data)
        .catch(() => [])
    },
    saveConsultantsEditedTotalPay ({ commit, dispatch }, editedTotalPay) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving total pay, please wait...' })

      return api.doPost({ path: PATH_CONSULTANTS_EDITED_TOTAL_PAY, data: editedTotalPay })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save total pay.')
          }

          notifySuccess(dispatch, 'Total pay saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save total pay')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    updateConsultantsEditedTotalPay ({ commit, dispatch }, editedTotalPay) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving total pay, please wait...' })

      return api.doPut({ path: PATH_CONSULTANTS_EDITED_TOTAL_PAY, data: editedTotalPay })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save total pay.')
          }

          notifySuccess(dispatch, 'Total pay saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save total pay')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default consultantsEditedTotalPay
